<template>
  <div class="card-on-card card-outline-secondary">
    <div class="card-header">
      <h5 class="mb-2 font-weight-bold">Informasi Produk</h5>
    </div>
    <div class="card-body">
      <div class="form-group row">
        <label class="col-lg-3 col-form-label form-control-label"
          >Nama Produk</label
        >
        <div class="col-lg-9">
          <input
            class="form-control"
            name="nonBookName"
            id="nonBookName"
            required
            type="text"
            v-on:keyup="seoRules('nonBookName', 'nonBookTag')"
            placeholder="Nama Produk"
          />
          <input
            type="hidden"
            class="form-control"
            name="nonBookTag"
            id="nonBookTag"
          />
        </div>
      </div>
      <div class="form-group row">
        <label class="col-lg-3 col-form-label form-control-label"
          >Kode Produk</label
        >
        <div class="col-lg-4">
          <input
            type="text"
            name="nonBookCode"
            id="nonBookCode"
            class="form-control"
          />
        </div>
        <div class="col-lg-5">
          <div class="input-group">
            <div class="input-group-prepend">
              <span
                class="p-1 input-group-text"
                style="font-size: 12px; font-weight: 500"
                >SEO</span
              >
            </div>
            <input
              class="form-control"
              type="text"
              name="nonBookSeo"
              readonly="true"
              id="nonBookSeo"
            />
          </div>
        </div>
      </div>

      <div class="form-group row">
        <label class="col-lg-3 col-form-label form-control-label"
          >Merek / Brand / Penerbit</label
        >
        <div class="col-lg-9">
          <select
            name="nonBookManufacturer"
            id="nonBookManufacturer"
            class="form-control"
          >
            <option
              v-for="(lp, index) in listPenerbit"
              :key="index"
              :value="lp.manufacturer_id"
            >
              {{ lp.name }}
            </option>
          </select>
        </div>
      </div>

      <!-- <div class="form-group row">
        <label class="col-lg-3 col-form-label form-control-label">SEO</label>
        <div class="col-lg-9">
          <input disabled class="form-control" type="text"  />
        </div>
      </div> -->

      <div class="form-group row">
        <label class="col-lg-3 col-form-label form-control-label"
          >Kategori</label
        >
        <div class="col-lg-3">
          <select
            @change="getCategoryVal"
            name="nonBookCategory"
            id="nonBookCategory"
            class="form-control"
          >
            <option
              v-for="(lc, index) in listCategory"
              :key="index"
              :value="lc.id"
            >
              {{ lc.title }}
            </option>
          </select>
        </div>

        <p id="loadingCategory1" class="mt-1 d-none small">
          Loading <i class="fa fa-spinner fa-spin"></i>
        </p>

        <div class="col-lg-3">
          <select
            @change="getSubCategoryVal"
            name="nonBookSubCategory"
            id="nonBookSubCategory"
            class="form-control d-none"
          >
            <option
              v-for="(lsc, index) in listSubCategory"
              :key="index"
              :value="lsc.id"
            >
              {{ lsc.title }}
            </option>
          </select>
        </div>

        <p id="loadingCategory2" class="mt-1 d-none small">
          Loading <i class="fa fa-spinner fa-spin"></i>
        </p>

        <div class="col-lg-3">
          <select
            name="nonBookSub2Category"
            id="nonBookSub2Category"
            class="form-control d-none"
          >
            <option
              v-for="(lsc, index) in listSub2Category"
              :key="index"
              :value="lsc.id"
            >
              {{ lsc.title }}
            </option>
          </select>
        </div>
      </div>

      <div class="form-group row">
        <label class="col-lg-2 col-form-label form-control-label"
          >Deskripsi</label
        >
        <div class="col-lg-10 offset-md-2">
          <quill-editor
            ref="myQuillEditor"
            @change="onEditorChange($event)"
            name="nonBookDescription"
            :v-model="description"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { quillEditor } from "vue-quill-editor";
// import axios from "axios";
import $ from "jquery";

export default {
  props: {
    description: String,
    nonBookName: String,
    onEditorChange: Function,
    getCategoryVal: Function,
    getSubCategoryVal: Function,
    listPenerbit: Array,
    listCategory: Array,
    listSubCategory: Array,
    listSub2Category: Array,
  },
  components: {
    quillEditor,
  },
  methods: {
    seoRules(first, replace) {
      let string = $("#" + first).val();
      let nilai = string.toLowerCase();

      let dan = nilai.split(/[&]/g).join(" dan ");
      let str = dan.split(/[^a-z0-9-A-Z]/g).join(", ");
      let str2 = dan.split(/[^a-z0-9-A-Z]/g).join("-");

      $("#" + replace).val(str);
      $("#nonBookSeo").val(str2);
    },
  },
};
</script>
